<template>
  <div class="pb-8 md:pb-20" v-if="ready">
    <div v-if="!isLoggedIn" class="text-center w-full pt-10 pb-6">
      <!--        <svg class="w-10 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
      <!--          <path-->
      <!--              d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"/>-->
      <!--        </svg>-->
      <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to subscribers</h2>
      <p class="font-normal text-2xl mb-8">You need to have an active print or digital subscription</p>

      <div class="flex flex-col justify-center sm:flex-row bg-blackLight max-w-[820px] mx-auto mb-4 sm:mb-10 min-h-[330px]">

        <div class="w-full sm:basis-1/2 relative">
          <div class="absolute  top-[-100px] left-[-2%] sm:top-[-20px] sm:left-[-20px] z-[1] opacity-20 sm:opacity-100">
            <nuxt-img
                format="webp"
                preload
                src="/subscribe/member-img-horse.png" alt="member subscribe" width="401" height="363"/>
          </div>
        </div>
        <div class="w-full sm:basis-1/2 flex flex-col justify-center z-[2]">
          <NuxtLink to="/subscribe" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">subscribe</NuxtLink>
          <div v-if="!userName" class="min-w-[250px] mx-auto">
            <p class="py-2 text-grayLight text-tiny">OR</p>
            <p class="text-white mb-2">Are You a Member?</p>
          </div>
          <NuxtLink v-if="!userName" to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold p-3 border-2 border-white hover:bg-darkRed text-white">login</NuxtLink>
        </div>
      </div>
    </div>
    <div v-else>
    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">{{ form.first_name + ' ' + form.last_name }} RIDER PROFILE</h1>
    <hr/>
    <div class="py-7 mt-8">
      <div class="grid grid-cols-1 md:grid-cols-3">
        <div>
          <table class="w-full">
            <tbody class="table-content-2 markup_content">
            <tr v-if="form.first_name">
              <td class="">
                <div class="flex">
                  <div class="flex-initial w-24">
                    <span class="font-bold">First Name:</span>
                  </div>
                  <div class="grow">
                    {{ form.first_name }}
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="form.last_name" class="align-top	">

              <td class="">
                <div class="flex">
                  <div class="flex-initial w-24">
                    <span class="font-bold">Last Name:</span>
                  </div>
                  <div class="grow">
                    {{ form.last_name }}
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="form.state">

              <td class="">
                <div class="flex">
                  <div class="flex-initial w-24">
                    <span class="font-bold">State:</span>
                  </div>
                  <div class="grow">
                    {{ form.state }}
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
        <div class="md:col-span-2 md:mt-0 py-3 px-2 mt-3"
             :class="(photos.length > 0 || form.videos.length > 0)?  'border-2 border-gray-100':''"
        >
          <!-- Media Tabs -->
          <div v-if="photos.length > 0" class="flex justify-center gap-2 mb-3">
            <button  v-if="photos.length > 0"
              @click="mediaTab = 'photos'"
              :class="[
                'px-3 py-1 font-bold uppercase text-sm transition-colors',
                mediaTab === 'photos'
                  ? 'bg-darkRed text-white'
                  : 'bg-white text-black border border-gray-300 hover:bg-gray-100'
              ]"
            >
              <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
              </svg>
              PHOTOS
            </button>
            <button  v-if="form.videos.length > 0"
              @click="mediaTab = 'videos'"
              :class="[
                'px-3 py-1 font-bold uppercase text-sm transition-colors',
                mediaTab === 'videos'
                  ? 'bg-darkRed text-white'
                  : 'bg-white text-black border border-gray-300 hover:bg-gray-100'
              ]"
            >
              <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor">
                <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/>
              </svg>
              VIDEOS
            </button>
          </div>

          <!-- Photos Slider -->
          <div v-show="mediaTab === 'photos'">
          <div class="flex justify-center">
            <div  v-if="photos.length > 0" :class="(photos.length > 2)?  'w-full':''">
              <swiper v-if="photos.length > 0"
                      class="media-slider"
                      :modules="[Navigation, Pagination, Scrollbar, A11y]"
                      :breakpoints="{
                          0: { slidesPerView: 1 },
                          768: { slidesPerView: photos.length > 2 ? 3 : photos.length }
                        }"
                      :centered-slides="true"
                      :pagination="{ clickable: true }"
                      :navigation="{ clickable: true }"
              >
                <swiper-slide v-for="(slide,index) in photos" :key="slide.id"
                              class="mx-4 w-auto max-w-[290px]"
                >
                  <nuxt-img
                      class="cursor-pointer w-full"
                      format="webp"
                      :src="
                 siteURL +
                      '/storage/images/riders/' +
                        slug +
                        '/cache/' +
                        slide.hash
                  "
                      :alt="slide.name"
                  /></swiper-slide>
              </swiper>
            </div>
            </div>
            <div v-if="photos.length > 0" class="text-center mt-4">
              <NuxtLink :to="'/rider/uploads/'+slug"
                        class="inline-block px-6 py-2 bg-darkRed text-white font-medium text-sm uppercase hover:opacity-80 rounded mt-3">
                <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                  <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
                </svg>
                add your photos to this profile
              </NuxtLink>
            </div>
          </div>
          <div v-if="photos.length == 0" class="flex flex-col justify-center items-center">
            <nuxt-img
                class="cursor-pointer w-[15rem]"
                format="webp"
                src="/add_photo_option.png"
                alt="no image"
            />
            <NuxtLink :to="'/rider/uploads/'+slug"
                      class="inline-block px-6 py-2 bg-darkRed text-white font-medium text-sm uppercase hover:opacity-80 rounded mt-3">
              <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
              </svg>
              add your photos to this profile
            </NuxtLink>
          </div>
          <!-- Videos Slider -->
          <div v-show="mediaTab === 'videos'">
            <div v-if="form.videos.length > 0" class="flex justify-center">
              <div class="w-full">
                <swiper
                    class="md:mt-0"
                    :modules="[Navigation, Scrollbar, A11y]"
                    :slides-per-view="1"
                    :navigation="{ clickable: true }"
                >
                  <swiper-slide v-for="item in form.videos" :key="item.id" class="w-auto">
                    <template v-if="item.video_url">
                      <iframe :title="item.title" class="w-full max-h-[350px] sm:h-[400px] md:h-[600px] xl:h-[800px] pr-[10%] pl-[10%]" :src="'https://www.youtube.com/embed/'+ item.video_source_id" width="100%" height="auto"
                              frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen/>
                    </template>
                    <template v-if="item.video_embedded">
                      <div v-html="item.video_embedded" class="flex justify-center"></div>
                    </template>
                    <!--                    <h2 class="text-2xl md:text-3xl text-center mt-4 font-semibold">{{item.title}}</h2>-->
                  </swiper-slide>
                </swiper>
              </div>

              <!-- Video Thumbnails List -->
<!--              <div class="swiper-container list-videos px-2 md:px-0 small_slider max-w-full sm:max-w-[600px] mx-auto">-->
<!--                <swiper-->
<!--                    class="md:mt-0"-->
<!--                    :modules="[Navigation, Scrollbar, A11y, Thumbs]"-->
<!--                    :slides-per-view="form.videos.length > 3 ? 3 : form.videos.length"-->
<!--                    :space-between="5"-->
<!--                    :navigation="{ clickable: true }"-->
<!--                    watch-slides-progress-->
<!--                    @swiper="setThumbsSwiper"-->
<!--                >-->
<!--                  <swiper-slide v-for="item in form.videos" :key="item.id">-->
<!--                    <div class="hover:cursor-pointer p-2 bg-gray-100 hover:bg-gray-200 transition-colors text-sm text-center">-->
<!--                      {{item.title}}-->
<!--                    </div>-->
<!--                  </swiper-slide>-->
<!--                </swiper>-->
<!--              </div>-->
            </div>

            <!-- No Videos Message -->
            <div v-else class="flex flex-col justify-center items-center py-20">
              <p class="text-gray-500 text-lg mb-4">No videos available</p>

              <NuxtLink :to="'/rider/uploads/'+slug"
                        class="inline-block px-6 py-2 bg-darkRed text-white font-medium text-sm uppercase hover:opacity-80 rounded mt-3">
                <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                  <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
                </svg>
                add your videos to this profile
              </NuxtLink>
            </div>
            <div v-if="form.videos.length > 0" class="text-center mt-4">

              <NuxtLink :to="'/rider/uploads/'+slug"
                        class="inline-block px-6 py-2 bg-darkRed text-white font-medium text-sm uppercase hover:opacity-80 rounded mt-3">
                <svg class="w-4 h-4 inline-block mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                  <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
                </svg>
                add your videos to this profile
              </NuxtLink>

            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row flex-wrap justify-between py-2 mt-3">
        <h2 class="text-4xl">Results</h2>
        <div>
          <p class="inline-block pr-3">Results Order</p>
          <select v-model="order"
                  class="mt-1 py-2 px-3 border focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                  @change="sort()">
            <option :value="false">Desc</option>
            <option :value="true">Asc</option>
          </select>
        </div>
      </div>




      <div v-if="shows.length>0" class="border shadow-md mb-11" v-for="show in shows">
        <div class="flex flex-row flex-wrap justify-between p-2.5 bg-slate-50">
          <h2>
            <NuxtLink :to="'/horse-shows/'+show.permalink"
                      class="font-bold font-['Arial'] text sm:text-lg text-darkRed hover:opacity-70 hover:text-darkBlue underline">
              {{ show.name }}, {{ show.city }}, {{ show.state }}
            </NuxtLink>
          </h2>
          <h2 class="font-bold font-['Arial']">
            {{
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              }).format(new Date(show.date_start))
            }} -
            {{
              new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              }).format(new Date(show.date_end))
            }}</h2>
        </div>
        <div>
          <table class="w-full text-xs md:text-base">
            <thead class="border border-2 border-x-0 border-x-0 border-b-black">
            <tr class="text-left  font-light sm:font-bold">
              <th class="text-center py-1 sm:py-3.5 w-[56px] sm:w-[7%] px-1">Position</th>
              <th class="py-1 sm:py-3.5  sm:w-[40%] px-1">Class</th>
              <th class="py-1 sm:py-3.5 w-[100px] sm:w-[23%]">Division</th>
              <th class="py-1 sm:py-3.5 w-[100px] sm:w-[23%]">Horse</th>
              <th class="py-1 sm:py-3.5 w-[40px] sm:w-[7%]">Points</th>
            </tr>

            </thead>
            <tbody v-if="show.results.length > 0" class="table-content-2 markup_content">
            <tr class="border-b font-light sm:font-medium text-left align-top" v-for="result in show.results">
              <th class="text-center py-1 sm:py-3.5 w-[56px] sm:w-[7%] px-1"><span class="font-bold">{{ result.place }}</span></th>
              <th class="py-1 sm:py-3.5 sm:w-[40%] px-1">{{ result.class_name }}</th>
              <th class="py-1 sm:py-3.5 w-[100px] sm:w-[23%]">{{ result.division_name }}</th>
              <th class="py-1 sm:py-3.5 w-[100px] sm:w-[23%]">
                <NuxtLink :to="'/horse/'+result.horse_permalink"
                          class="text-darkRed hover:opacity-70 hover:text-darkBlue underline">{{ result.horse_name }}
                </NuxtLink>
              </th>
              <th class="py-1 sm:py-3.5 w-[40px] sm:w-[7%]">{{ result.points }}</th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  </div>
  <div v-else>
    <LoadersSpinner />
  </div>
</template>

<style>

.swiper-button-next:after, .swiper-button-prev:after{
  color: #111827;
}

</style>

<script setup>
import {http} from "~/utils/http";
import {Rider,Page} from "~/composables/nhTypes";
import {computed, ref} from "vue";
import {Navigation, Pagination, Scrollbar, A11y, Thumbs} from "swiper";
import {Swiper, SwiperSlide} from "swiper/vue";
import {usePhoto} from "~/composables";
import {useHead} from "nuxt/app";
import {useSiteTitle,useSiteURL} from "~/composables/state";
import { useMainStore} from '~/stores/main'

const siteTitle = useSiteTitle();
const route = useRoute();
const slug = route.params.slug;
const form = ref(new Rider());
const photos = ref([]);
const shows = ref([]);
const order = ref(false);
const ready = ref(false);
const isLoggedIn = ref(true);
const siteURL = useSiteURL();
const page = ref(new Page());
const mainStore = useMainStore()
const userName = computed(() => mainStore.userName)
useHead({
  title: computed(() => page.value.meta_title + siteTitle.value) ,
  meta: [
    {name: 'description', content: computed(() => page.value.meta_description?? siteTitle.value)},
    {name: 'keywords', content: computed(() => page.value.meta_keywords?? siteTitle.value)},
    { property: 'og:title', content: computed(() => page.value.meta_title + siteTitle.value) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => page.value.meta_description?? siteTitle.value) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
  ],
})
const thumbsSwiper = ref(null);
const mediaTab = ref('photos');
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};
const getData = async () => {
  try {
    await http
        .get("/api/results/rider/" + slug)
        .then((response) => {
          form.value.videos = response.data.rider.videos? response.data.rider.videos : [];
          form.value.first_name = response.data.rider.first_name;
          form.value.last_name = response.data.rider.last_name;
          form.value.state = response.data.rider.state_province ? response.data.rider.state_province.name : null;
          photos.value = response.data.rider_photos;
          shows.value = response.data.results;
          page.value.meta_title = form.value.first_name + ' ' + form.value.last_name + ' - ';
          page.value.meta_description = 'Rider information and horse show results history for ' + form.value.first_name + ' ' + form.value.last_name + ', ' + form.value.state;
          page.value.meta_keywords =form.value.first_name + ' ' + form.value.last_name + ', ' + form.value.state + ', rider, horse, horse show, results';
          ready.value = true;
          sort();
        });
  } catch (e) {
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
};

const sort = () => {
  if (shows.value.length > 0) {
    if (order.value) {
      shows.value = shows.value.sort((a, b) => {
        if (a.date_start > b.date_start) {
          return 1
        }
        if (a.date_start < b.date_start) {
          return -1
        }
        return 0
      });
    } else {
      shows.value = shows.value.sort((a, b) => {
        if (a.date_start < b.date_start) {
          return 1
        }
        if (a.date_start > b.date_start) {
          return -1
        }
        return 0
      });
    }
  }
}
getData();
</script>
